import { render, staticRenderFns } from "./UGSStoreOnSalesConfig.vue?vue&type=template&id=2ce6004c&scoped=true&"
import script from "./UGSStoreOnSalesConfig.vue?vue&type=script&lang=js&"
export * from "./UGSStoreOnSalesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6004c",
  null
  
)

export default component.exports